/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import running_order_firebase from "./firebase/running_order_firebase";
import UfFb from "./firebase/unsynced_files_firebase";
import Context from "./context/context";
import { openDB } from "idb";
import bcrypt from "bcryptjs";
import styles from "./css/SetupForm.module.css";
import plusIcon from "./images/plus.svg";
import "react-calendar/dist/Calendar.css";
import "./css/user.css";
import bgLogin from "./images/bgLogin.jpeg";
import foodDoAdmin from "./images/foodDoAdmin.png"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { v4 as uuidv4 } from "uuid";
import FBConfig from "./FBConfig";
import ReadFBLoginDevices from "./firebase/handle_loggedIn_device";

let redirect_path = '/page1';
let temp_login_data;
const Login = ({ setLoginState }) => {

  const context = useContext(Context);
  const { setForceRenderPage1, setForceRenderOrdersPage, generateMenues, toggleAlarm, newLoginData, setNewLoginData, setUnSyncCount, showWarning, calculateOrderValues } = context;
  const [newUserForm, setNewUserForm] = useState(false);
  const [edit, setEdit] = useState(false);
  const [newUser, setNewUser] = useState({});
  const [series, setSeries] = useState([]);
  const [users, setUsers] = useState([]);
  const [currentWorkingDay, setCurrentWorkingDay] = useState(0);
  const [newWorkingDayForm, setNewWorkingDayForm] = useState(0);
  const [errorSeries, setErrorSeries] = useState(false);
  const Navigate = useNavigate();
  const [updatedCurrentWorkingDay, setUpdatedCurrentWorkingDay] = useState(0);
  const [multiDeviceWarning, setMultiDeviceWarning] = useState(false)

  const [credentials, setCredentials] = useState({
    username: "",
    password: "",
    user_type: ["1", "3"]
  });

  const [isLoading, setIsLoading] = useState(false);
  const [isPageLoading, setIsPageLoading] = useState(false);

  const postLogin = async () => {
    const brand = await JSON.parse(localStorage.getItem('brands'))?.[0]
    if (!brand) return console.error("No brands found in localstorage")
    const server_url = 'https://api.myfooddo.com/logos/' + brand + '.jpeg'
    const serverFile = await fetch(server_url)
    console.log(serverFile)
    if (serverFile.ok) {
      fetch('http://127.0.0.1:7878/logo_sync', {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          url: server_url
        })
      })
    }
  }

  const onChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const saveCurrentDate = () => {
    console.log("Updating current date...");
    fetch("https://api.myfooddo.com/outlet/UpdateCurrentDate", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify([
        {
          current_working_day: updatedCurrentWorkingDay.toString(),
          outlet_uuid: localStorage.getItem("outlet_uuid"),
        },
      ]),
    }).then(res => {

      if (+res.status === 502) {
        saveCurrentDate();
        return;
      }
      else
        return res.json();
    }).then((res) => {
      // console.log(res);
      console.log("Current date updated through API");
      localStorage.setItem(
        "current-working-day",
        updatedCurrentWorkingDay.toString()
      );
      getOutletDetail();
      setNewWorkingDayForm(false);;
    }).catch((err) => {
      console.log(err.message)
    });
  };

  useEffect(() => {
    const reLogin = JSON.parse(sessionStorage.getItem("retry-login-credentials"))
    if (reLogin) {
      getOutletDetail()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (newLoginData?.user_name) {
      setCredentials({ ...credentials, username: newLoginData.user_name, password: newLoginData.user_password });
      loginHandler(null, {
        username: newLoginData.user_name,
        password: newLoginData.user_password,
        user_type: "1"
      })
      setTimeout(() => setNewLoginData({}), 3000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  async function getDateOrders() {
    if (+localStorage.getItem('user_type') === 3) return;
    let DBOpenReq = indexedDB.open("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    DBOpenReq.addEventListener("error", (err) => { console.warn(err); });
    DBOpenReq.addEventListener("success", (ev) => {
      let db = ev.target.result;
      let tx = db.transaction("Orders", "readwrite");
      let store = tx.objectStore("Orders");
      store.clear()
      db.close();
    });
    const current_working_day = +localStorage.getItem("current-working-day");
    const outlet = localStorage.getItem("outlet_uuid");
    const order_upto = localStorage.getItem("offline-order-upto");

    const working_days_collection = [];
    const dates_json = [];

    for (let i = 0; i < +order_upto; i++) {
      let generatedTime = new Date(current_working_day).setDate(new Date(current_working_day).getDate() - i);
      // console.log(new Date(generatedTime).toUTCString());

      dates_json.push({
        day: 0 - i,
        date: generatedTime,
        date_string: new Date(generatedTime).toUTCString()
      })

      working_days_collection.push({
        outlet_uuid: outlet,
        working_day: generatedTime,
      });
    }

    localStorage.setItem("dates_json", JSON.stringify(dates_json));

    // console.log(JSON.stringify(working_days_collection));

    const getOrderDate = () => {
      fetch("https://api.myfooddo.com/order/getOrderDate", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(working_days_collection),
      })
        .then((res) => {
          if (+res.status === 200)
            return res.json();
          else if (+res.status === 500)
            getDateOrders();
        })
        .then((data) => {
          let DBOpenReq = indexedDB.open("FoodDo", +localStorage.getItem("IDBVersion") || 1);
          DBOpenReq.addEventListener("error", (err) => { console.warn(err); });
          DBOpenReq.addEventListener("success", (ev) => {
            let db = ev.target.result;
            let tx = db.transaction("Orders", "readwrite");
            let store = tx.objectStore("Orders");

            // console.log(data);
            // console.log(data.result);
            data?.result?.forEach((collection) => {
              collection?.forEach((i) => {
                i.IDENTIFIER = i.order_uuid;
                store.put(i);
              });
            });
          });
        });
    }
    getOrderDate();
  }

  const blockHandleTimer = useRef({ Time: 0, ID: null });

  function thisFunction(version, stores, content) {

    const id = setTimeout(() => {
      showWarning({
        message: 'Make Sure Multiple Tabs are Not Open!!',
        classname: 'active-red',
        time: 100000
      })
    }, 5000);

    console.log(`opening indexeddb for version ${version} to store data`);
    let DBOpenReq = window.indexedDB.open("FoodDo", version);

    DBOpenReq.onerror = function () {
      console.log("Couldn't create database");
      window.location.reload();
    };

    DBOpenReq.onblocked = function () {
      console.log("Couldn't create database due to the operation being blocked");
      sessionStorage.setItem("retry-login-credentials", JSON.stringify(credentials))
      localStorage.setItem("IDBVersion", version);
      window.location.reload();
    };

    DBOpenReq.onupgradeneeded = (ev) => {

      clearTimeout(id)
      showWarning({ remove: true })
      console.log("currentVersion", version);
      console.log("on upgrade needed");

      let db = DBOpenReq.result;
      stores.forEach((store, i) => {

        if (!db.objectStoreNames.contains(store)) {
          db.createObjectStore(store, {
            keyPath: "IDENTIFIER",
          });
        }
      });
    };

    DBOpenReq.onsuccess = async (dbEvent) => {

      clearTimeout(id)
      showWarning({ remove: true })
      // alert("Operation is succeed")
      sessionStorage.removeItem("retry-login-credentials");
      clearTimeout(blockHandleTimer.current);
      clearInterval(sessionStorage.getItem("notification-warning-timeout"));
      document?.querySelector(".notification-container")?.classList.remove("active-red");

      console.log("db open request succeed");

      let db = dbEvent.target.result;
      localStorage.setItem("IDBVersion", version);

      function addNewCollection(name, json) {
        if (name.toLowerCase().includes("outlet")) {
          // console.log(name);
          // console.log(name.toLowerCase().includes("outlet"), json);
          localStorage.setItem("outlet-name", json.outlet_details.outlet_title);

          localStorage.setItem("offline-order-upto", json.offline_order_upto);
          json.current_working_day = localStorage.getItem("current-working-day")

          getDateOrders();
        }
        let tx = db.transaction(name, "readwrite");
        console.log(name)
        if (!Array.isArray(json)) {
          json.IDENTIFIER = json[`${name}_uuid`];
          let store = tx.objectStore(`${name}`);
          store.put(json);
        }

        if (Array.isArray(json) && name.toLowerCase().includes('brand')) {
          const brands = json?.map(i => i.brand_uuid).filter(i => i)
          localStorage.setItem("brands", JSON.stringify(brands))
        }

        Array.isArray(json) && json.length > 0 &&
          json.forEach((obj, index) => {
            if (name === "payment_modes") obj.IDENTIFIER = obj.payment_mode_uuid;
            else if (name === "seats") obj.IDENTIFIER = obj.seat_uuid;
            else if (name === "role_management") obj.IDENTIFIER = obj.role_uuid;
            else if (name === "item_grouping") obj.IDENTIFIER = obj.item_group_uuid;
            else if (name === "customer") obj.IDENTIFIER = obj.customer_mobile;
            else obj.IDENTIFIER = obj[`${name}_uuid`] || `${index}`;

            let store = tx.objectStore(`${name}`);
            store.put(obj);
          });
      }

      content.forEach((json, i) => {

        const key = Object.keys(json)[0].toLocaleLowerCase();
        addNewCollection(key, json[key]);
        if (++i === content.length) {
          setIsLoading(false);

          sessionStorage.setItem("haveRead", true);
          setTimeout(() => {
            sessionStorage.removeItem("firebase-data-injected");
            db.close();
            bcrypt
              .genSalt(6)
              .then((salt) => bcrypt.hash(credentials.password, salt))
              .then((hashedPassword) =>
                localStorage.setItem("hashedPassword", hashedPassword)
              );

          }, 1000);
        }
      });
      localStorage.setItem("refresh_status", "0");
      running_order_firebase.ReadValueFromFirebase(
        localStorage.getItem("outlet_uuid"),
        { setForceRenderOrdersPage, toggleAlarm, setForceRenderPage1, calculateOrderValues }
      );

      UfFb.ReadValueFromFirebase(
        localStorage.getItem("outlet_uuid"),
        setForceRenderOrdersPage,
        setForceRenderPage1,
        generateMenues,
        setUnSyncCount
      );
      await saveUserRestrictions()
      Navigate(redirect_path);
      postLogin()
      setLoginState(uuidv4());
    };
  }

  const getOutletDetail = user_uuid => {

    console.log("Getting outlet details...")
    let endPoint = 'outlet/getOutletDetail';
    if (+localStorage.getItem('user_type') === 3) {
      endPoint = endPoint + '/chef'
      redirect_path = '/kds'
    }

    // fetch(`http://localhost:5000/${endPoint}`, {
    fetch(`https://api.myfooddo.com/${endPoint}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify({
        outlet_uuid: localStorage.getItem("outlet_uuid"),
        user_uuid
      }),
    })
      .then((res) => {
        if (+res.status === 502) {
          getOutletDetail();
          return;
        }
        return res.json();
      })
      .then((content) => {

        console.log("Outlet details received")
        const result = content.result;
        const stores = [
          "running_orders",
          "unsynced_files",
          "Orders",
          "reconciliation",
          "sync_in"
        ];

        let flush = result[0]?.outlet?.flush
        if (flush) {
          sessionStorage.setItem("flush", flush);
          sessionStorage.setItem("tutorial", 1);
        }

        result.forEach(json => {
          const key = Object.keys(json)[0].toLocaleLowerCase();
          stores.push(key);
        });

        let pastVersion = +localStorage.getItem("IDBVersion") || 0;
        console.log("pastVersion", pastVersion);
        thisFunction(pastVersion + 10, stores, result)
      })
      .catch((err) => {
        console.warn("error in fetching details", err);
        getOutletDetail();
      });
  };

  const saveUser = () => {
    if (series.find((item) => item.series === newUser.series)) {
      setErrorSeries("Existing series");
      setTimeout(() => setErrorSeries(false), 3000);
    } else if (
      newUser.series === "" ||
      newUser.kot_start === "" ||
      newUser.kot_end === ""
    ) {
      setErrorSeries("please fill all the info");
      setTimeout(() => setErrorSeries(false), 3000);
    } else if (
      newUser.kot_start <=
      series?.map((a) => parseInt(a.kot_end)).reduce((a, b) => Math.max(a, b))
    ) {
      setErrorSeries("please insert Greater Kot_start Number");
      setTimeout(() => setErrorSeries(false), 3000);
    } else if (newUser.kot_start > newUser.kot_end) {
      setErrorSeries("please insert Greater Kot_end Number");
      setTimeout(() => setErrorSeries(false), 3000);
    } else {
      const addUserSeries = () => {
        fetch("https://api.myfooddo.com/outlet/AddUserInvoiceSeries", {
          method: "post",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify([
            {
              invoice_series: {
                ...series[0],
                ...newUser,
                next_kot_number: newUser.kot_start,
              },
              outlet_uuid: localStorage.getItem("outlet_uuid"),
            },
          ]),
        })
          .then(res => {
            if (+res.status === 502) {
              addUserSeries();
              return;
            }
            else
              return res.json();
          })
          .then((res) => {
            // console.log(res);
            setNewUserForm(false);
            setNewWorkingDayForm(true);
          })
          .catch((err) => {
            setErrorSeries(err.message);
            setTimeout(() => setErrorSeries(false), 3000);
          });
      }
      addUserSeries()
    }
  };

  const handleLoginData = content => {

    console.log("Login Succeed");
    setIsPageLoading(true);
    function storeNewData() {

      localStorage.setItem("refresh_status", "1");
      localStorage.setItem("login_time", (new Date()).getTime());
      localStorage.setItem("token", content.token);
      sessionStorage.setItem("token", content.token);
      localStorage.setItem("Simple_logout", "1");
      localStorage.setItem("syncin_approved", JSON.stringify([]));
      sessionStorage.setItem("currency_sign", "Rs.");
      sessionStorage.setItem("date_format", "dd/mm/yy");
      sessionStorage.setItem("outlet_time_zone", "GMT+5:30");
      sessionStorage.setItem("restrictions", JSON.stringify([]));
      localStorage.setItem("user_type", content.user_type)
      console.log("Checking Invoice Series.")

      const checkInVoiceSeries = () => {
        fetch("https://api.myfooddo.com/outlet/CheckInvoiceSeries", {
          method: "post",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify([
            {
              user_uuid: content.user_uuid,
              outlet_uuid: content.outlet_uuid,
            },
          ]),
        })
          .then(res => {
            if (+res.status === 502) {
              checkInVoiceSeries();
              return;
            }
            else
              return res.json();
          })
          .then((res) => {
            // console.log(res);
            console.log("invoice series checked")
            if (res.success) {
              setCurrentWorkingDay(res.data.current_working_day);
              setNewWorkingDayForm(true);
            }
            else if (res?.success === false) {
              setSeries(res.invoice_series);
              setUsers(res.users);
              setNewUserForm(true);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
      if (+content.user_type === 3) {
        console.log('content.user_type', content.user_type)
        getOutletDetail(content.user_uuid);
      }
      else {
        checkInVoiceSeries();
      }
    }

    const userType = +localStorage.getItem("user_type");
    const pastUser = localStorage.getItem("user_uuid");
    pastUser && console.log(pastUser === content.user_uuid)
    pastUser && console.log(`${pastUser} && ${content.user_uuid}`)

    if (userType === 3 || (pastUser && pastUser !== content.user_uuid)) {

      // console.clear();
      console.log("Deleting indexeddb database...")
      var DBDeleteRequest = window.indexedDB.deleteDatabase("FoodDo");
      DBDeleteRequest.onerror = function (event) {
        console.log("Error deleting database.");
        console.log("Error : ", event.result);
        window.location.reload();
      };
      DBDeleteRequest.onsuccess = function (event) {
        console.log("Database deleted successfully");
        console.log("Storing new data")
        storeNewData();
      };
    } else storeNewData();
  }

  const loginHandler = async (e, credentialsData = credentials) => {

    e?.preventDefault();
    setIsLoading(true);
    let auth = localStorage.getItem("hashedPassword");

    // fetch("http://localhost:5000/user/login", {
    fetch("https://api.myfooddo.com/user/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(credentialsData),
    })
      .then((res) => {
        if (+res.status === 502) {
          loginHandler()
          return
        }
        else
          return res.json()
      })
      .then((content) => {
        console.log("content", content);
        if (!content.token) {
          setIsLoading(false)
          return alert(content.message);
        }

        localStorage.setItem("outlet_uuid", content.outlet_uuid);
        localStorage.setItem("user_uuid", content.user_uuid);

        ReadFBLoginDevices({
          logout: () => {
            sessionStorage.clear()
            localStorage.setItem("Simple_logout", "0");
            window.location.pathname = "/login";
          }
        })

        let deviceId = sessionStorage.getItem('deviceId') || uuidv4()
        const path = `${content.outlet_uuid}/loggedIn-devices/${content.user_uuid}`
        FBConfig.get(FBConfig.ref(FBConfig.db, path)).then(res => {
          const loggedInDeviceId = res.val()
          console.log({ loggedInDeviceId })
          if (!loggedInDeviceId || loggedInDeviceId === deviceId || sessionStorage.getItem('BYPASS')?.includes('LOGIN')) {
            if (!loggedInDeviceId) FBConfig.set(FBConfig.ref(FBConfig.db, path), deviceId)
            handleLoginData(content)
          }
          else {
            sessionStorage.setItem('deviceId', deviceId)
            temp_login_data = { ...content }
            setIsLoading(false);
            setMultiDeviceWarning(true)
          }
        })
      })
      .catch((err) => {
        if (auth) {
          bcrypt.compare(credentials.password, auth).then((result) => {
            if (result) {

              sessionStorage.setItem("token", localStorage.getItem("token"));
              localStorage.setItem("Simple_logout", "1");
              localStorage.setItem("refresh_status", "1");

              Navigate(redirect_path);
              postLogin()
              setLoginState(uuidv4());
              localStorage.setItem("refresh_status", "0");
            } else {
              setIsLoading(false);
              alert("incorrect Password");
            }
          });
        }
        else
          loginHandler(e);
      });
  };

  const saveUserRestrictions = async () => {
    if (+localStorage.getItem('user_type') === 3) return;
    let db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    let tx = db.transaction("user", "readwrite");
    let store = tx.objectStore("user");

    var usersData = await store.get(localStorage.getItem("user_uuid"));
    console.log("users", usersData)

    tx = db.transaction("role_management", "readwrite");
    store = tx.objectStore("role_management");
    let roleData = await store.getAll();
    let restrictions = roleData.find(a => a.role_uuid === usersData.role_uuid)?.restrictions || []
    restrictions = JSON.stringify(restrictions)
    sessionStorage.setItem("restrictions", restrictions)
  }

  const loginHere = async () => {
    const path = `${localStorage.getItem('outlet_uuid')}/loggedIn-devices/${localStorage.getItem('user_uuid')}`
    const deviceId = sessionStorage.getItem('deviceId')
    await FBConfig.set(FBConfig.ref(FBConfig.db, path), deviceId)
    setMultiDeviceWarning(false)
    handleLoginData(temp_login_data)
  }

  return (
    <>
      {!sessionStorage.getItem("retry-login-credentials")
        ? <div id="login-container" onKeyDown={(e) => e.key === "Enter" ? newUserForm ? edit ? saveUser() : setEdit(true) : newWorkingDayForm ? saveCurrentDate() :
          loginHandler()
          : ""}>
          {multiDeviceWarning && <MultipleDeviceWarning
            cancel={() => setMultiDeviceWarning(false)}
            loginHere={loginHere}
          />}
          <div className="foodDoAdmin"><img src={foodDoAdmin} alt="" /></div>
          <div className="form">
            <h1>Sign In</h1>
            <div className="input-container">
              <label htmlFor="username" className="form-label">
                Username
              </label>
              <input
                type="username"
                className="form-input"
                name="username"
                id="username"
                value={credentials.username}
                onChange={onChange}
                autoComplete="off"
                required
              />
            </div>

            <div className="input-container">
              <label htmlFor="password" className="form-label">
                Password
              </label>
              <input
                type="password"
                className="form-input"
                name="password"
                id="password"
                value={credentials.password}
                onChange={onChange}
                minLength="5"
                autoComplete="off"
                required
              />
            </div>

            {!isLoading ? (
              <button className="submit-btn" onClick={loginHandler}>
                Login
              </button>
            ) : (
              <button className="submit-btn" id="loading-screen">
                <svg viewBox="0 0 100 100">
                  <path
                    d="M10 50A40 40 0 0 0 90 50A40 44.8 0 0 1 10 50"
                    fill="currentColor"
                    stroke="none"
                  >
                    <animateTransform
                      attributeName="transform"
                      type="rotate"
                      dur="1s"
                      repeatCount="indefinite"
                      keyTimes="0;1"
                      values="0 50 51;360 50 51"
                    ></animateTransform>
                  </path>
                </svg>
              </button>
            )}
          </div>
          <div
            style={{
              width: "100vw",
              height: "100vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {newUserForm ? (
              <div className="secondary_screen">
                <img
                  src={bgLogin}
                  alt=""
                  style={{ width: "100%", height: "100%" }}
                />

                <div className="logoutPopup" style={{ left: "0px" }}>
                  <InvoiceSeriesList
                    style={{ width: "100%", height: "100%" }}
                    series={series}
                    users={users}
                    saveUser={saveUser}
                    errorSeries={errorSeries}
                    newUser={newUser}
                    setNewUser={setNewUser}
                    edit={edit}
                    setEdit={setEdit}

                  />
                </div>
              </div>
            ) : newWorkingDayForm ? (
              <div className="secondary_screen">
                <img
                  src={bgLogin}
                  alt=""
                  style={{ width: "100%", height: "100%" }}
                />

                <div className="logoutPopup" style={{ left: "0px" }}>
                  <UpdateCurrentWorkingDay
                    currentWorkingDay={currentWorkingDay}
                    saveCurrentDate={saveCurrentDate}
                    updatedCurrentWorkingDay={updatedCurrentWorkingDay}
                    setUpdatedCurrentWorkingDay={setUpdatedCurrentWorkingDay}
                  />
                </div>
              </div>
            ) : isPageLoading ? (
              <PageLoading />
            ) : (
              ""
            )}
          </div>
        </div>
        : <PageLoading />}
    </>
  );
};
export default Login;

const PageLoading = () => {
  return <div className="secondary_screen">
    <img
      src={bgLogin}
      alt=""
      style={{ width: "100%", height: "100%" }}
    />
    <div className="logoutPopup" style={{ left: "0px" }}>
      <div style={{ width: "50px", height: "50px" }}>
        <svg viewBox="0 0 100 100">
          <path
            d="M10 50A40 40 0 0 0 90 50A40 44.8 0 0 1 10 50"
            fill="#ffffff"
            stroke="none"
          >
            <animateTransform
              attributeName="transform"
              type="rotate"
              dur="1s"
              repeatCount="indefinite"
              keyTimes="0;1"
              values="0 50 51;360 50 51"
            ></animateTransform>
          </path>
        </svg>
      </div>
    </div>
  </div>
}

const InvoiceSeriesList = ({ series, users, saveUser, errorSeries, newUser, setNewUser, edit, setEdit }) => {

  useEffect(() => {
    setNewUser({
      user_uuid: localStorage.getItem("user_uuid"),
      series_type: "L",
      series: "",
      kot_start:
        series
          ?.map((a) => parseInt(a.kot_end))
          .reduce((a, b) => Math.max(a, b)) + 1,
      kot_end:
        series
          ?.map((a) => parseInt(a.kot_end))
          .reduce((a, b) => Math.max(a, b)) + 250,
      next_order_number: "1",
    });
  }, []);

  return (
    <div className={styles.formGroup} style={{ background: "white" }} >
      <div>
        <h2>Invoice Series</h2>
      </div>
      <table className="user-table">
        <thead>
          <tr>
            <th>Invoice Series</th>
            <th>Type</th>
            <th>Kot Range</th>
            <th>Current User</th>
          </tr>
        </thead>
        <tbody>
          {series.map((item) => (
            <tr key={Math.random()}>
              <td>{item.series || "-"}</td>
              <td>
                {item.series_type === "L"
                  ? "Local"
                  : item.series_type === "S"
                    ? "Server"
                    : "-"}
              </td>
              <td>
                {item.kot_start || "-"} To {item.kot_end || "-"}
              </td>
              <td>
                {users.find((user) => user.user_uuid === item.user_uuid)
                  ?.user_title || "-"}
              </td>
            </tr>
          ))}
          {edit ? (
            <tr>
              <td>
                <input
                  type="text"
                  name="series"
                  className={styles.numberInput}
                  placeholder="Series"
                  value={newUser.series}
                  onChange={(e) =>
                    setNewUser({
                      ...newUser,
                      series: e.target.value
                        .replace(/[^A-Za-z]/gi, "")
                        .toUpperCase(),
                    })
                  }
                  style={{ width: "50%" }}
                  maxLength={3}
                />
              </td>
              <td>Local</td>
              <td
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <input
                  id="kotStart"
                  type="number"
                  className={styles.numberInput}
                  style={{ width: "40%" }}
                  placeholder="Kot Start"
                  value={newUser.kot_start}
                  onChange={(e) =>
                    setNewUser({ ...newUser, kot_start: e.target.value })
                  }
                  maxLength={4}
                />
                To
                <input
                  id="kotStart"
                  type="number"
                  style={{ width: "40%" }}
                  className={styles.numberInput}
                  placeholder="Kot End"
                  value={newUser.kot_end}
                  onChange={(e) =>
                    setNewUser({ ...newUser, kot_end: e.target.value })
                  }
                  maxLength={4}
                />
              </td>
              <td>
                {users.find((user) => user.user_uuid === newUser.user_uuid)
                  ?.user_title || "-"}
              </td>
            </tr>
          ) : (
            ""
          )}
        </tbody>
      </table>
      {errorSeries || ""}
      {edit ? (
        <button className={styles.submit} onClick={saveUser}>
          Save changes
        </button>
      ) : (
        <button
          className={styles.addMealButton}
          onClick={() => setEdit(true)}
          type="button"
        >
          <img src={plusIcon} alt="" />
        </button>
      )}
    </div>
  );
};

const UpdateCurrentWorkingDay = ({
  onSave,
  currentWorkingDay,
  saveCurrentDate,
  updatedCurrentWorkingDay,
  setUpdatedCurrentWorkingDay
}) => {
  const [newCurrentWorkingDay, setNewCurrentWorkingDay] = useState(0);
  const [edit, setEdit] = useState(false);

  useEffect(() => {
    setNewCurrentWorkingDay(new Date());
    setEdit(true)
  }, []);
  useEffect(() => {
    setUpdatedCurrentWorkingDay((new Date(Date.UTC(new Date(newCurrentWorkingDay)?.getFullYear().toString(), new Date(newCurrentWorkingDay)?.getMonth().toString(), new Date(newCurrentWorkingDay)?.getDate().toString(), '00', '00', '00'))).getTime());
    setEdit(true)
  }, [newCurrentWorkingDay]);

  // console.log("date", new Date(newCurrentWorkingDay)?.getFullYear().toString(), new Date(newCurrentWorkingDay)?.getMonth().toString(), new Date(newCurrentWorkingDay)?.getDate().toString(), '00', '00', '00')
  // console.log("date", updatedCurrentWorkingDay)

  return (
    <div className={styles.formContainer}>
      <div className={styles.formGroup} style={{ background: "white", width: "fit-content", display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center", textAlign: "center", padding: "1.5rem" }}>
        <div>
          <h2>Select Working Day</h2>
          <div
            className="login_date_picker"
            style={{
              width: "100%",

              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "10px",
              flexDirection: "column"
            }}
          >
            {/* <Calendar
              value={newCurrentWorkingDay}
              onChange={(date) =>
                setNewCurrentWorkingDay(new Date(date))
              }
            /> */}
            <DatePicker
              id="date-from"
              className="data-picker test"
              dateFormat="d/M/y"
              selected={newCurrentWorkingDay}
              maxDate={new Date()}
              onChange={(date) => {
                setNewCurrentWorkingDay(new Date(date))
              }}
              style={{ textAlign: "center" }}

              wrapperClassName=""
              shouldCloseOnSelect={false}
              isCalendarOpen={true}
            />
          </div>
          <i
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "10px",
            }}
          >
            Last Working Day :
            {(sessionStorage.getItem("date_format") || "dd/mm/yy")
              .replace(
                "mm",
                (
                  "00" +
                  (
                    new Date(parseInt(currentWorkingDay))?.getMonth() + 1
                  ).toString()
                ).slice(-2)
              )
              .replace(
                "yy",
                (
                  "0000" +
                  new Date(parseInt(currentWorkingDay))?.getFullYear().toString()
                ).slice(-4)
              )
              .replace(
                "dd",
                (
                  "00" +
                  new Date(parseInt(currentWorkingDay)).getDate().toString()
                ).slice(-2)
              )}
          </i>
        </div>
        {edit ? (
          <button className={styles.submit} onClick={() => saveCurrentDate(updatedCurrentWorkingDay)}>
            Continue
          </button>
        ) : (
          <button className={styles.submit} id="loading-screen">
            <svg viewBox="0 0 100 100">
              <path
                d="M10 50A40 40 0 0 0 90 50A40 44.8 0 0 1 10 50"
                fill="#ffffff"
                stroke="none"
              >
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  dur="1s"
                  repeatCount="indefinite"
                  keyTimes="0;1"
                  values="0 50 51;360 50 51"
                ></animateTransform>
              </path>
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

const MultipleDeviceWarning = ({ cancel, loginHere }) => {
  return (
    <div id="popup-container">
      <div className="multi-device-warning-container">
        <p>You will be logged out of other devices</p>
        <div className="buttons">
          <button id="cancel" onClick={cancel}>Cancel</button>
          <button id="confirm" onClick={loginHere}>Login</button>
        </div>
      </div>
    </div>
  )
}